import React from 'react'
import './style.css';
import {ErrorHandlerTemplate} from '@components/layout/error-handler/error-handler.template';
import Bugsnag from '@bugsnag/js'

export class ErrorHandlerComponent extends React.Component {

    state = {
        error: null,
        errorInfo: null,
    };

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        Bugsnag.notify(error);
    }

    render() {
        if (this.state.errorInfo) {
            return (<ErrorHandlerTemplate></ErrorHandlerTemplate>);
        }
        return this.props.children;
    }
}
